"use strict";
// The Yearly Summaries tab (#515): STM002's "Yearly Maintenance Breakdown" — one column per contract
// year, sell and cost by category. Each year's cost is what every area does that year (its programme:
// repaint, service, wash or nothing; the PA sheets). PAYG (decision 1, DD 2026-10-23): a year's sell is
// its cost ÷ (1 − the contract's GP %), so the years add up to the contract price, with no interest.
// Even Spread and Higher Year One (slice 3, maintenance-payments.ts): each category's contract sell is
// shared out by the payment schedule, and the year's finance interest is its own row. Pure.
Object.defineProperty(exports, "__esModule", { value: true });
exports.yearlySummary = yearlySummary;
const maintenance_ts_1 = require("./maintenance.js");
const maintenance_payments_ts_1 = require("./maintenance-payments.js");
const PAYG = { type: 'PAYG', financeRate: 0 };
const sum = (items, value) => items.reduce((total, item) => total + value(item), 0);
/** One category's sell in a year: PAYG grosses up the year's own cost; the other types share out its contract sell (D11 × F75 / F83). */
function categorySell(work, c, index, grossUp, totalCost, schedule) {
    if (schedule.type === 'PAYG')
        return work.cost[c] * grossUp;
    return totalCost[c] * grossUp * (schedule.shares[index] ?? 0);
}
/** The contract's Yearly Summaries, years labelled from `startYear`, paid by `terms` (PAYG unless said). */
function yearlySummary(contract, startYear, terms = PAYG) {
    const grossUp = contract.gp < 1 ? 1 / (1 - contract.gp) : 0;
    // Higher Year One's first payment: the repaint's cost, but no more than year 1's own work (a repaint moved later).
    const firstPayment = Math.min(contract.repaint.totalCost, contract.byYear[0]?.totalCost ?? 0);
    const schedule = (0, maintenance_payments_ts_1.paymentSchedule)(terms.type, contract.byYear.map((w) => w.totalCost * grossUp), firstPayment, terms.financeRate);
    const totalCost = Object.fromEntries(maintenance_ts_1.CONTRACT_CATEGORIES.map((c) => [c, sum(contract.byYear, (w) => w.cost[c])]));
    const years = contract.byYear.map((work, i) => {
        const categories = Object.fromEntries(maintenance_ts_1.CONTRACT_CATEGORIES.map((c) => [c, { sell: categorySell(work, c, i, grossUp, totalCost, schedule), cost: work.cost[c] }]));
        const interest = schedule.interest[i] ?? 0;
        return {
            number: work.number,
            label: startYear + work.number - 1,
            categories,
            interest,
            sell: sum(maintenance_ts_1.CONTRACT_CATEGORIES, (c) => categories[c].sell) + interest,
            cost: work.totalCost,
            hours: work.hours,
            litres: work.litres,
        };
    });
    const totals = Object.fromEntries(maintenance_ts_1.CONTRACT_CATEGORIES.map((c) => [c, { sell: sum(years, (y) => y.categories[c].sell), cost: sum(years, (y) => y.categories[c].cost) }]));
    const sell = sum(years, (y) => y.sell);
    const cost = sum(years, (y) => y.cost);
    return {
        paymentType: terms.type,
        years,
        totals,
        interest: sum(years, (y) => y.interest),
        sell,
        cost,
        gp: sell > 0 ? (sell - cost) / sell : 0,
        hours: sum(years, (y) => y.hours),
        litres: sum(years, (y) => y.litres),
    };
}
